// extracted by mini-css-extract-plugin
module.exports = {"ctaPanel":"ContactCTA_ctaPanel__eHX00","container":"ContactCTA_container__2P2y2","headline":"ContactCTA_headline__1fFVe","button":"ContactCTA_button__17gKI"};